module.exports = __webpack_public_path__ + "static/sensenet-footerlogo-5c80020053f8da25da0d200bef029a47.png";